export default "__VITE_ASSET__DUFvL5h8__"